// Include console-history.js for Node package.
require('./console-history')
